import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { Subscription } from 'rxjs';
import { CurrencyService } from 'src/app/util/currency.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  PINE_LAB_STAFF_GUIDE_S1,
  PINE_LAB_STAFF_GUIDE_S2,
  PINE_LAB_STAFF_GUIDE_S3,
  PINE_LAB_STAFF_GUIDE_S4,
  PINE_LAB_STAFF_GUIDE_S5,
  PINE_LAB_STAFF_GUIDE_S6,
  CROSS,
} from 'src/defaultImages.js';

@Component({
  selector: 'app-staff-guide-popup',
  templateUrl: './staff-guide-popup.component.html',
  styleUrls: ['./staff-guide-popup.component.css'],
})
export class StaffGuidePopupComponent implements OnInit {
  images = {
    CROSS: CROSS,
    PINE_LAB_STAFF_GUIDE_S1: PINE_LAB_STAFF_GUIDE_S1,
    PINE_LAB_STAFF_GUIDE_S2: PINE_LAB_STAFF_GUIDE_S2,
    PINE_LAB_STAFF_GUIDE_S3: PINE_LAB_STAFF_GUIDE_S3,
    PINE_LAB_STAFF_GUIDE_S4: PINE_LAB_STAFF_GUIDE_S4,
    PINE_LAB_STAFF_GUIDE_S5: PINE_LAB_STAFF_GUIDE_S5,
    PINE_LAB_STAFF_GUIDE_S6: PINE_LAB_STAFF_GUIDE_S6,
  };
  currency: string = '';
  subscription = new Subscription();
  translationText: any;
  staffGuideData = [
    {
      text: 'On the EasyEat Credit Card Terminal, press anywhere to start the payment process',
      image: this.images.PINE_LAB_STAFF_GUIDE_S1,
    },
    {
      text: 'Select Cloud Based Tx from the given options',
      image: this.images.PINE_LAB_STAFF_GUIDE_S2,
    },
    {
      text: 'Select Get Open Txn. from the given options',
      image: this.images.PINE_LAB_STAFF_GUIDE_S3,
    },
    {
      text: 'Click OK to confirm the amount to be processed',
      image: this.images.PINE_LAB_STAFF_GUIDE_S4,
    },
    {
      text: 'Select the desired payment mode. Click on SALE for payments via Card and UPI SALE for payments via eWallet',
      image: this.images.PINE_LAB_STAFF_GUIDE_S5,
    },
    {
      text: 'Scan the QR or ask the customer to insert/tap the card',
      image: this.images.PINE_LAB_STAFF_GUIDE_S6,
    },
  ];

  constructor(
    private _modalRef: NzModalRef,
    private _curr: CurrencyService,
    public _translateService: TranslateService,
    private _sanitizer: DomSanitizer
  ) {
    this.currency = this._curr.getCurrency();
    this.subscription.add(
      this._translateService.get(['SHARED']).subscribe((translation) => {
        this.translationText = translation.SHARED;
        this.staffGuideData = [
          {
            text: this.translationText.STAFF_GUIDE_T1,
            image: this.images.PINE_LAB_STAFF_GUIDE_S1,
          },
          {
            text: `${this.translationText.SELECT_TEXT} <b>Cloud Based Tx</b> ${this.translationText.STAFF_GUIDE_T2}`,
            image: this.images.PINE_LAB_STAFF_GUIDE_S2,
          },
          {
            text: `${this.translationText.SELECT_TEXT} <b>Get Open Txn.</b> ${this.translationText.STAFF_GUIDE_T2}`,
            image: this.images.PINE_LAB_STAFF_GUIDE_S3,
          },
          {
            text: this.translationText.STAFF_GUIDE_T3,
            image: this.images.PINE_LAB_STAFF_GUIDE_S4,
          },
          {
            text: `${this.translationText.STAFF_GUIDE_T4} <b>SALE</b> ${this.translationText.STAFF_GUIDE_T5} <b>UPI SALE</b> ${this.translationText.STAFF_GUIDE_T6}`,
            image: this.images.PINE_LAB_STAFF_GUIDE_S5,
          },
          {
            text: this.translationText.STAFF_GUIDE_T7,
            image: this.images.PINE_LAB_STAFF_GUIDE_S6,
          },
        ];
      })
    );
  }
  ngOnInit() {}
  cancelClicked() {
    this._modalRef.close();
  }
  sanitizeHtml(html: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }
}
